import { render, staticRenderFns } from "./DashboardPro.vue?vue&type=template&id=2b304e29&"
import script from "./DashboardPro.vue?vue&type=script&lang=js&"
export * from "./DashboardPro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports